module.exports = __webpack_public_path__ + "static/media/icon_trash.c3012f0c.svg";